export const MAX_RATING = 5
